import {Page} from "../../flair/Page.es6";

Page.match("/pay/").go(function() {
	console.log("pay index");
	const form = document.querySelector("section form");
	const selectProduct = document.querySelector("[name='product']");
	const inputReference = document.querySelector("[name='ref']");
	const selectShipping = document.querySelector("[name='shipping']");
	const inputSpecialOffer = document.querySelector("[name='special-offer']");
	const parser = new DOMParser();

	formChange.call(form);
	form.addEventListener("change", formChange);

	function formChange() {
		if(!selectProduct.value) {
			return;
		}

		let formData = new FormData(document.querySelector("form.product-details"));
		formData.set("do", "update");
		form.classList.add("loading");

		fetch(window.location, {
			method: "post",
			credentials: "same-origin",
			body: formData,
		})
			.then(response => {
				let responseUrl = new URL(response.url);
				if(responseUrl.pathname !== location.pathname) {
					location.href = response.url;
					return;
				}

				form.classList.remove("loading");
				return response.text();
			})
			.then(updateFormHtml);
	}

	function updateFormHtml(html) {
		const newDocument = parser.parseFromString(html, "text/html");
		document.querySelector("output").innerHTML = newDocument.querySelector("output").innerHTML;
		document.querySelector("button[name=do][value=pay]").outerHTML = newDocument.querySelector("button[name=do][value=pay]").outerHTML;
	}
});
